<template>
    <div>
      <div class="filters" style="margin-bottom: 20px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <span class="t-label">{{$t('engagement_select_clients')}}</span>
            <el-select
                style="width: 100%"
                class="inputs"
                no-data-text="no date"
                v-model="clientId"
                :placeholder="$t('engagement_select_clients')"
                size="mini">
              <el-option
                  v-for="item in clientList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="setFilter(item.id, stageId, codeId)">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="t-label">{{$t('engagement_select_stages')}}</span>
            <el-select
                style="width: 100%"
                class="inputs"
                no-data-text="no date"
                v-model="stageId"
                :placeholder="$t('engagement_select_stages')"
                size="mini">
              <el-option
                  v-for="item in stageList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="setFilter(clientId, item.id, codeId)">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="t-label">{{$t('engagement_select_code')}}</span>
            <el-select
                style="width: 100%"
                class="inputs"
                no-data-text="no date"
                v-model="codeId"
                :placeholder="$t('engagement_select_code')"
                size="mini">
              <el-option
                  v-for="item in codeList"
                  :key="item"
                  :label="item"
                  :value="item"
                  @click.native="setFilter(clientId, stageId, item)">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
        <el-table
                :data="businessUnitEngagementsList"
                border
                style="width: 100%">
            <el-table-column
                    prop="code"
                    :label="$t('bu_tab_info_code')"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="name"
                    :label="$t('bu_tab_info_name')">
            </el-table-column>
            <el-table-column
                    :label="$t('bu_tab_info_owner')"
                    width="80"
                    align="center"
                    header-align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.owner"
                               size="mini"
                               type="success"
                               circle></el-button>
                </template>
            </el-table-column>
            <el-table-column
                    width="200"
                    :label="$t('bu_tab_info_action')">
                <template slot-scope="scope">
                    <el-button size="mini" @click="$router.push(`/engagements?companyId=${scope.row.companyId}&engagementId=${scope.row.id}&taskId=0`)" >{{$t('bu_tab_info_select')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
  import moment from 'moment'
  import axios from "axios";
  import { mapMutations } from "vuex";
  export default {
    computed: {
      businessUnitEngagementsList() {
        return this.$store.state.businessUnitEngagementsList
      }
    },
    name: "BusinessUnitEngagements",
    data(){
      return {
        moment:moment,
        clientId: 0,
        clientList: [],
        stageId: 0,
        stageList: [],
        codeId: 'All',
        codeList: []
      }
    },
    mounted() {
      this.getClientsList()
      this.getStagesList()
      this.getCodesList()
    },
    methods: {
      ...mapMutations({
        getBusinessUnitEngagementList: 'getBusinessUnitEngagementList'
      }),
      getClientsList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyClients/list?companyId=${this.$route.query.companyId} `)
            .then(response => {
              console.log('---', response.data);
              this.clientList = [{ name: 'All', id: 0 }].concat(response.data.list);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      getStagesList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyStages/listFilter?companyId=${this.$route.query.companyId}&entityType=2`)
            .then(response => {
              console.log('---', response.data.list);
              this.stageList = [{ name: 'All', id: 0 }].concat(response.data.list);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      getCodesList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/businessUnits/engagementsCodeListBU?businessUnitId=${this.$route.query.businessUnitId}`)
            .then(response => {
              console.log('---', response.data.list);
              this.codeList = ['All'].concat(response.data.list.filter((value, index, self) => self.indexOf(value) === index));
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      setFilter(clientId, stageId, code) {
        console.log('clientId, stageId, code', clientId, stageId, code)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${this.$route.query.businessUnitId || null}`)
            .then(response => {
              let list = response.data.list
              // filter list
              if (clientId) {
                // TODO filter clients
                list = list.filter(val => val.engagementClient.some(val => val.companyClientId === clientId))
              }
              if (stageId) {
                list = list.filter(val => val.engagementStageId === stageId)
              }
              if (code !== 'All') {
                list = list.filter(val => val.code === code)
              }
              this.getBusinessUnitEngagementList(list)
              console.log('list', list)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }
    }
  }
</script>

<style lang="less" scoped>
.filters {
  margin-bottom:20px;
  .t-label {
    font-size: 14px;
  }
}
</style>
